/* Tysk katalog for locale-vat-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'vat.term': 'MwSt.-Zeitraum',
  'vat.termHelp': 'Ein MwSt.-Zeitraum ist eine Periode, für die du die Mehrwertsteuer meldest. Die meisten melden zweimonatlich - 6 Zeiträume pro Jahr. Für jeden Zeitraum werden Umsatzsteuer und Vorsteuer summiert, und die Differenz wird an den Staat gezahlt oder von ihm erstattet.',
  'vat.termShort': 'Zeitraum',
  'vat.deadline': 'FRIST',
  'vat.amountHelp': 'Zu zahlende MwSt. bedeutet, dass du dem Staat etwas schuldest, weil die Umsatzsteuer höher war als die Vorsteuer. MwSt.-Guthaben bedeutet, dass du Geld zurückbekommst, weil du beim Einkauf mehr MwSt. gezahlt hast, als du beim Verkauf eingenommen hast.',
  'vat.openReturn': 'Meldung öffnen',
  'vat.sortHelp': 'Die Zeiträume sind nach Status sortiert: „Handlung nötig“ muss jetzt gemeldet werden, „Bevorstehend“ sind künftige Perioden und „Früher“ sind bereits gemeldet oder bezahlt.',
  'vat.noTerms': 'Noch keine MwSt.-Zeiträume',
  'vat.incompleteBasisTitle': 'Die MwSt.-Grundlage ist unvollständig',
  'vat.incompleteBasisText': 'Die MVA-melding wird nicht als vollständig angezeigt, weil die Journalabdeckung nicht dokumentiert ist. Dokumentberechnungen können weiterhin zur Diagnose genutzt werden, aber nicht als vollständige Buchhaltungsgrundlage.',
  'vat.needsAction': 'Handlung nötig',
  'vat.upcoming': 'Bevorstehend',
  'vat.earlier': 'Früher',
  'vat.toPay': 'Zu zahlende MwSt.',
  'vat.toPayHelp': 'Gesamte offene MwSt., bei der die Umsatzsteuer höher ist als die Vorsteuer.',
  'vat.paidIn': 'Eingezahlt',
  'vat.paidInHelp': 'MwSt.-Zahlungen, die du in Plumme für Zeiträume erfasst hast.',
  'vat.refunded': 'Erstattet',
  'vat.refundedHelp': 'MwSt.-Erstattungen, die du in Plumme für Zeiträume erfasst hast.',
  'vat.perTerm': 'Pro Zeitraum',
  'vat.returnStatus': 'Status der MVA-melding',
  'vat.period': 'Zeitraum',
  'vat.due': 'Frist',
  'vat.calculated': 'Berechnete Abrechnung',
  'vat.settlement': 'Abrechnung',
  'vat.cancelPayment': 'Zahlung stornieren',
  'vat.date': 'Datum',
  'vat.amount': 'Betrag',
  'vat.reference': 'Referenz',
  'vat.referencePh': 'Z. B. Onlinebanking, OCR',
  'vat.payments': 'Zahlungen',
  'vat.paymentsHelp': 'Übersicht der Zahlungen, die für diesen MwSt.-Zeitraum erfasst sind.',
  'vat.noPayments': 'Keine Zahlungen erfasst',
  'vat.fromAccount': 'Von Konto',
  'vat.edit': 'Bearbeiten',
  'vat.cancel': 'Stornieren',
  'vat.cancelPaymentTitle': 'Zahlung stornieren?',
  'vat.cancelPaymentConfirm': 'Ja, Zahlung stornieren',
  'vat.backToTerms': 'Zurück zu den Zeiträumen',
  'vat.importedBasisTitle': 'Aus einem anderen Buchhaltungssystem importiert',
  'vat.importedBasisHelp': 'Die Zahlen wurden als Grundlage importiert. Du kannst die MVA-melding über den normalen Ablauf erstellen, einreichen und bei Bedarf stornieren.',
  'vat.outputVat': 'Umsatzsteuer',
  'vat.outputVatHelp': 'MwSt., die du im Zeitraum beim Verkauf eingenommen hast.',
  'vat.inputVat': 'Vorsteuer',
  'vat.inputVatHelp': 'Abzugsfähige MwSt., die du im Zeitraum beim Einkauf gezahlt hast.',
  'vat.netVat': 'Netto-MwSt.',
  'vat.netHelp': 'Umsatzsteuer minus Vorsteuer. Ein positiver Betrag wird gezahlt, ein negativer Betrag ist ein Guthaben.',
  'vat.checkStatus': 'Status prüfen',
  'vat.checkStatusHelp': 'Zeigt den in Plumme gespeicherten Status der MVA-melding. Ein automatischer Status von Altinn oder Skatteetaten ist in diesem Plumme-Bereich noch nicht angebunden.',
  'vat.seePayment': 'Zahlung ansehen',
  'vat.seePaymentHelp': 'Sieh dir die für diesen MwSt.-Zeitraum erfassten Zahlungen an — Datum, Konto, Betrag und Referenz.',
  'vat.codeOverview': 'Code-Übersicht für die Einreichung',
  'vat.codeOverviewHelp': 'Die MVA-melding wird aus standardisierten MwSt.-Codes von Skatteetaten aufgebaut. Jeder Code fasst eine bestimmte Art von Verkauf oder Einkauf zusammen. Die Grundlage ist der Betrag ohne MwSt. Bei Umkehr der Steuerschuldnerschaft werden Umsatz- und Vorsteuer angezeigt, auch wenn der Nettobetrag 0 ist. Tippe auf einen Code, um zu sehen, was dorthin gehört.',
  'vat.codeTapHint': 'Tippe auf einen Code, um zu sehen, was dorthin gehört.',
  'vat.code': 'Code',
  'vat.description': 'Beschreibung',
  'vat.basis': 'Grundlage',
  'vat.rate': 'Satz',
  'vat.vat': 'MwSt.',
  'vat.calculatedFrom': 'Berechnet aus dem, was du in der App erfasst hast',
  'vat.delete': 'Löschen',
  'vat.annulCustoms': 'Stornieren',
  'vat.annulled': 'Storniert',
  'vat.showAnnulledCustoms': 'Stornierte anzeigen',
  'vat.showActiveCustoms': 'Aktive anzeigen',
  'vat.customsAnnulled': 'Zollanmeldung storniert',
  'vat.customsAnnulFailed': 'Die Zollanmeldung konnte nicht storniert werden.',
  'vat.registerCustoms': 'Zollanmeldung erfassen',
  'vat.customsHelp': 'Erfasse eine Zollanmeldung für Waren, die du aus dem Ausland eingeführt hast. Plumme berechnet die Einfuhr-MwSt. aus dem statistischen Wert und trägt sie unter dem richtigen Code in die Meldung ein.',
  'vat.flowHelp': 'Prüfe die Zahlen aus den gebuchten Belegen. Plumme kann die MVA-melding nicht senden: Du reichst sie im Dienst von Skatteetaten ein und markierst den Zeitraum danach hier als außerhalb von Plumme eingereicht. Dann kannst du die Zahlung erfassen. Der Status „Eingereicht“ kann wieder entfernt werden, falls er versehentlich gesetzt wurde.',
  'vat.filing.statusFiled': 'Außerhalb von Plumme eingereicht',
  'vat.filing.statusFiledPaid': 'Außerhalb von Plumme eingereicht und bezahlt',
  'vat.filing.statusNotFiled': 'Nicht als eingereicht markiert',
  'vat.filing.reviewFigures': 'Zahlen prüfen',
  'vat.filing.reviewedToast': 'Die Zahlen sind geprüft. Reiche die MVA-melding bei Skatteetaten ein.',
  'vat.filing.markOutside': 'Als außerhalb von Plumme eingereicht markieren',
  'vat.filing.clearStatus': 'Status „Eingereicht“ entfernen',
  'vat.filing.dialogTitle': 'MVA-melding bei Skatteetaten einreichen',
  'vat.filing.cannotSend': 'Plumme kann die MVA-melding nicht senden oder signieren. Du reichst sie selbst bei Skatteetaten ein und markierst den Zeitraum danach hier als eingereicht.',
  'vat.filing.step1': 'Öffne die MVA-melding im Dienst von Skatteetaten und trage die Zahlen für diesen Zeitraum aus Plumme ein.',
  'vat.filing.step2': 'Reiche die Meldung dort ein, signiere sie und bewahre die Quittung auf.',
  'vat.filing.step3': 'Markiere den Zeitraum hier als außerhalb von Plumme eingereicht. Dann kannst du die Zahlung erfassen, und der Zeitraum gilt beim Jahresabschluss als eingereicht.',
  'vat.filing.termNotEnded': 'Der Zeitraum ist noch nicht vorbei. Die MVA-melding kann erst nach Ende des Zeitraums eingereicht werden.',
  'vat.filing.filedDate': 'Einreichungsdatum',
  'vat.filing.reference': 'Referenz (optional)',
  'vat.filing.referencePh': 'Zum Beispiel die Referenz auf der Quittung von Skatteetaten',
  'vat.filing.comment': 'Kommentar (optional)',
  'vat.filing.lockNote': 'Sobald der Zeitraum als eingereicht markiert ist, werden die Belege der Periode gesperrt. Änderungen müssen dann als Korrektur erfolgen.',
  'vat.filing.clearText': 'Der Zeitraum gilt dann in Plumme als nicht eingereicht, und die Belege der Periode werden wieder entsperrt. Die Änderung wird mit Person und Zeitpunkt protokolliert. Der Status bei Skatteetaten ändert sich nicht.',
  'vat.filing.clearReason': 'Begründung (optional)',
  'vat.filing.markedToast': 'Der Zeitraum ist als außerhalb von Plumme eingereicht markiert',
  'vat.filing.clearedToast': 'Status „Eingereicht“ entfernt',
  'vat.filing.failed': 'Der MwSt.-Status konnte nicht aktualisiert werden.',
  'vat.filing.payAfterFiled': 'Verfügbar, sobald die MVA-melding bei Skatteetaten eingereicht und hier als eingereicht markiert ist.',
  'vat.filing.markedOn': 'In Plumme markiert',
  'vat.filing.referenceLabel': 'Referenz',
  'vat.filing.commentLabel': 'Kommentar',
  'vat.filing.statusNote': 'Plumme ruft den Status nicht von Skatteetaten ab. Der Status hier ist das, was in Plumme markiert wurde.',
  'vat.addComment': 'Kommentar hinzufügen',
  'vat.customs': 'Zollanmeldung',
  'vat.correctCustoms': 'Zollanmeldung korrigieren',
  'vat.saveCustoms': 'Zollanmeldung speichern',
  'vat.fetchFromAltinn': 'Aus Altinn abrufen',
  'vat.fetchFromAltinnHelp': 'Referenz und Zollwert automatisch aus übermittelten Anmeldungen ausfüllen.',
  'vat.declarationRef': 'Anmeldungsreferenz',
  'vat.declarationRefPh': 'Referenz von Tolletaten',
  'vat.statisticalValue': 'Statistischer Wert',
  'vat.vatCode': 'MwSt.-Code',
  'vat.attachments': 'Anhänge / Importspur',
  'vat.uploadAttachment': 'Anhang hochladen',
  'vat.attachmentHelp': 'Optional, aber empfohlen für den Prüfpfad und die spätere Importnachverfolgung.',
  'vat.customsBasis': 'Zollwert',
  'vat.calculatedVat': 'Berechnete MwSt.',
  'vat.deductible': 'Abzugsfähigkeit',
  'vat.settlementDate': 'Abrechnungsdatum',
  'vat.settlementType': 'Art der Abrechnung',
  'vat.useDueDate': 'Fälligkeitsdatum',
  'vat.useDueDateHelp': 'Abrechnungsdatum auf das Fälligkeitsdatum der MVA-melding setzen',
  'vat.addSurcharges': 'Zinsen/Gebühren hinzufügen',
  'vat.surcharges': 'Zinsen und Gebühren',
  'vat.removeSurcharges': 'Entfernen',
  'vat.lateInterest': 'Verzugszinsen',
  'vat.lateInterestHelp': 'Wird als Zinsaufwand auf 8150 gebucht',
  'vat.penaltyFee': 'Gebühr oder Zwangsgeld',
  'vat.penaltyFeeHelp': 'Wird auf 7799 gebucht und ist nicht abzugsfähig',
  'vat.surchargeTotal': 'Wird vom Konto abgebucht',
  'vat.surchargeNote': 'Zinsen und Gebühren sind keine Mehrwertsteuer. Sie werden als Aufwand erfasst und vom Konto abgebucht, ändern aber die MwSt.-Abrechnung des Zeitraums nicht.',
  'vat.kid': 'KID',
  'vat.payTitle': 'MwSt. an Skatteetaten zahlen',
  'vat.payHelp': 'Kontonummer und KID kommen von Skatteetaten, sobald die Meldung bearbeitet wurde. Die Zahlung direkt aus der Bank ist noch nicht angebunden, daher wird die Zahlung vorerst in Plumme erfasst.',
  'vat.awaitingAuthority': 'Kommt von Skatteetaten',
  'vat.pay': 'Zahlen',
  'vat.kidHelp': 'KID aus der MVA-melding',
  'vat.authorityAccount': 'Kontonummer von Skatteetaten',
  'vat.authorityAccountHelp': 'Die Kontonummer von Skatteetaten',
  'vat.notRegistered': 'Das Unternehmen ist nicht als MwSt.-registriert eingestellt',
  'vat.view': 'Ansicht',
  'vat.viewHelp': 'Wechsle zwischen „Zeiträume“ — eine Karte je MwSt.-Zeitraum mit Status und Frist — und „Übersicht“, die zusammenfasst, was du über alle Zeiträume schuldest, bezahlt hast und zurückbekommst.',
  'vat.viewTerms': 'Zeiträume',
  'vat.viewOverview': 'Übersicht',
  'vat.filing.notFiled': 'Nicht übermittelt',
  'vat.filing.upcomingStatus': 'Anstehend',
  'vat.filing.importedArchive': 'Importiertes Archiv',
  'vat.vatReceivable': 'MwSt.-Guthaben',
  'vat.vatToPay': 'Zu zahlende MwSt.',
  'vat.noVat': 'Keine MwSt.',
  'vat.receivableShort': 'Guthaben',
  'vat.remainingToPay': 'Noch zu zahlen',
  'vat.termLabel': '{n}. Zeitraum {year}',
  'vat.noTermsHelp': 'Sobald das Unternehmen MwSt.-registriert ist, zeigt Plumme hier Zeiträume, Fristen und die berechnete MwSt.',
  'vat.youOwe': 'Du schuldest',
  'vat.youAreOwed': 'Du hast ein Guthaben',
  'vat.noVatToSettle': 'Keine MwSt. abzurechnen',
  'vat.refund': 'Erstattung',
  'vat.paymentNoun': 'Zahlung',
  'vat.settlementNoun': 'Abrechnung',
  'vat.acctBankDeposit': 'Bankguthaben',
  'vat.acctTaxDeductionAccount': 'Steuerabzugskonto',
  'vat.acctCash': 'Kasse',
  'vat.accountFallback': '{code} Konto',
  'vat.settlementFullyRegistered': 'Vollständig erfasst',
  'vat.settlementPartiallyRegistered': 'Teilweise erfasst',
  'vat.settlementNotRegistered': 'Nicht erfasst',
  'vat.editRefund': 'Erstattung bearbeiten',
  'vat.editPayment': 'Zahlung bearbeiten',
  'vat.receivedOn': 'Eingegangen auf',
  'vat.paidFrom': 'Bezahlt von',
  'vat.noPaymentsHelp': 'Sobald du eine Zahlung oder Erstattung für den Zeitraum erfasst, wird sie hier angezeigt.',
  'vat.addRefund': 'Erstattung hinzufügen',
  'vat.addPayment': 'Zahlung hinzufügen',
  'vat.cancelPaymentConfirmPrefix': 'Möchtest du die {kind} über',
  'vat.cancelPaymentConfirmDate': ' erfasst am {date}',
  'vat.cancelPaymentConfirmSuffix': '? Der Betrag wird aus dem MwSt.-Zeitraum entfernt und kann nicht wiederhergestellt werden.',
  'vat.overpaid': 'Zu viel bezahlt',
  'vat.overrefunded': 'Zu viel erstattet bekommen',
  'vat.remainingToReceive': 'Noch zu erhalten',
  'vat.registerSettlement': 'Abrechnung erfassen',
  'vat.registerPayment': 'Zahlung erfassen',
  'vat.registerRefund': 'Erstattung erfassen',
  'vat.inYourFavor': 'zu deinen Gunsten',
  'vat.toTaxAuthority': 'an Skatteetaten',
  'vat.receivedBack': 'Erstattet erhalten',
  'vat.archiveCannotSettle': 'Importierte Historie kann nicht als neuer Plumme-Zeitraum abgerechnet werden.',
  'vat.noVatToSettleForTerm': 'Für den Zeitraum ist keine MwSt. abzurechnen.',
  'vat.sourceImported': 'Importiert',
  'vat.sourceManual': 'Manuell erfasst',
  'vat.registerVatRefund': 'MwSt.-Erstattung erfassen',
  'vat.registerVatPayment': 'MwSt.-Zahlung erfassen',
  'vat.saveRefund': 'Erstattung speichern',
  'vat.savePayment': 'Zahlung speichern',
  'vat.remainingHint': 'Rest {amount}',
  'vat.notRegisteredHelp': 'Sobald das Unternehmen in den Einstellungen als MwSt.-registriert eingestellt ist, zeigt Plumme hier MwSt.-Zeiträume, Codeübersicht und Abrechnung.',
  'vat.reviewReadyToast': 'Die MVA-melding ist zur Prüfung vorbereitet',
  'vat.customsAltinnNotConnected': 'Der Altinn-Import für Zollanmeldungen ist noch nicht angebunden.',
  'vat.selectAttachmentToUpload': 'Wähle einen Anhang zum Hochladen',
  'vat.customsDefaultDescription': 'Zollanmeldung',
  'vat.customsDateTermHint': 'Das Datum muss innerhalb von {period} liegen.',
  'vat.customs81': '25 % mit Vorsteuerabzug',
  'vat.customs82': '25 % ohne Vorsteuerabzug',
  'vat.customs83': '15 % mit Vorsteuerabzug',
  'vat.customs84': '15 % ohne Vorsteuerabzug',
  'vat.customs85': '0 % Einfuhr',
  'vat.customsSaved': 'Zollanmeldung gespeichert',
  'vat.customsSaveFailed': 'Die Zollanmeldung konnte nicht gespeichert werden.',
  'vat.customsDeleted': 'Zollanmeldung gelöscht',
  'vat.customsDeleteFailed': 'Die Zollanmeldung konnte nicht gelöscht werden.',
  'vat.refundSaved': 'Erstattung gespeichert',
  'vat.paymentSaved': 'Zahlung gespeichert',
  'vat.paymentSaveFailed': 'Die Zahlung konnte nicht gespeichert werden.',
  'vat.refundCancelled': 'Erstattung storniert',
  'vat.paymentCancelled': 'Zahlung storniert',
  'vat.paymentCancelFailed': 'Die Zahlung konnte nicht storniert werden.',
  'vat.supplierSearch': 'Lieferant suchen oder hinzufügen...',
  'vat.supplierClose': 'Lieferantenauswahl schließen',
  'vat.supplierNone': 'Keine Lieferanten gefunden.',
  'vat.supplierNew': 'Neuer Lieferant',
  'vat.supplierName': 'Name',
  'vat.supplierOrg': 'Org.-Nr.',
  'vat.supplierEmail': 'E-Mail',
  'vat.supplierPhone': 'Telefon',
  'vat.customsPostingExplanation': 'Verwende die Zahlen aus der Zollanmeldung. Nicht abzugsfähige MwSt. muss auf das richtige Aufwands- oder Anlagenkonto gebucht werden.',
  'vat.nonDeductibleAccount': 'Konto für nicht abzugsfähige MwSt.',
  'vat.nonDeductibleAccountHelp': 'Wähle dasselbe Aufwands- oder Anlagenkonto wie für die Anschaffung. Ein Konto muss vor dem Buchen angegeben werden.',
  'voucherList.titleHelp': 'Ein Beleg ist die Dokumentation hinter einer Buchung: Rechnung, Quittung, sonstiger Verkauf, Zollanmeldung oder freie Buchung. Hier siehst du die Belege, die für das gewählte Geschäftsjahr aus dem Backend geladen wurden.',
  'voucherList.backToTrialBalance': 'Zurück zur Summen- und Saldenliste',
  'voucherList.backToIncomeStatement': 'Zurück zur Gewinn- und Verlustrechnung',
  'voucherList.accountBadge': 'Konto {number} · {name}',
  'voucherList.vatCodeBadge': 'MwSt.-Code {code}',
  'voucherList.viewOptions': 'Anzeigeoptionen',
  'voucherList.noneForVatCode': 'Keine Belege für MwSt.-Code {code} im gewählten Zeitraum gefunden.',
  'voucherList.noneForAccount': 'Keine Belege auf {number} {name} in {year} gebucht.',
  'voucherList.noneMatchSearch': 'Keine Belege entsprechen der Suche.',
  'voucherList.noneInView': 'Keine Belege entsprechen der Ansicht.',
  'voucherList.ledgerLinesMissing': 'Den Belegen fehlen Buchungszeilen aus dem Backend.',
  'voucherList.debit': 'Soll',
  'voucherList.credit': 'Haben',
  'voucherList.colVoucher': 'Beleg',
  'voucherList.colNumber': 'Beleg-Nr.',
  'voucherList.colDate': 'Datum',
  'voucherList.inlineVat': 'MwSt.',
  'voucherList.kindInvoice': 'Rechnung',
  'voucherList.kindSupplier': 'Lieferant',
  'voucherList.kindCreditNote': 'Gutschrift',
  'voucherList.kindManual': 'Manueller Beleg',
  'voucherList.kindPurchase': 'Kauf',
  'voucherList.kindOtherSale': 'Sonstiger Verkauf',
  'voucherList.kindMileage': 'Fahrtenbuch',
  'voucherList.kindCustoms': 'Zollanmeldung',
  'voucherList.kindCustomsCorrection': 'Periodenkorrektur der Zollanmeldung',
  'voucherList.kindBankPosting': 'Bankbuchung',
  'voucherList.kindPayment': 'Zahlung',
  'voucherList.kindPayroll': 'Lohn',
  'voucherList.kindPayrollPayment': 'Lohnzahlung',
  'voucherList.kindReversal': 'Stornierung',
  'voucherList.kindPublicFees': 'Öffentliche Abgaben',
  'voucherList.kindAssetDisposal': 'Anlagenabgang',
  'voucherList.kindYearEnd': 'Jahresabschluss',
  'voucherList.kindQuote': 'Angebot',
  'voucherList.kindOrderConfirmation': 'Auftragsbestätigung',
  'voucherList.filterSales': 'Verkauf',
  'voucherList.filterSupplierInvoice': 'Lieferantenrechnung',
  'voucherList.filterFreePosting': 'Freie Buchung',
  'voucherList.missingAttachment': 'Anhang fehlt',
  'voucherList.hasAttachment': 'Mit Anhang',
  'voucherList.unpaid': 'Unbezahlt',
  'voucherList.showAnnulled': 'Stornierte anzeigen',
  'voucherList.hidePayments': 'Zahlungen ausblenden',
  'voucherList.includeAnnulled': 'Stornierte einschließen',
  'vat.amountOnly': 'Nur Umsatzsteuer',
  'voucherList.onlyAnnulled': 'Nur stornierte anzeigen',
  'voucherList.paid': 'Bezahlt',
  'voucherList.partiallyPaid': 'Teilweise bezahlt',
  'voucherList.annulled': 'Storniert',
  'voucherList.attachmentLost': 'Beleg verloren',
  'voucherList.openInvoiceList': 'In der Rechnungsliste ansehen',
  'voucherList.editSale': 'Verkauf bearbeiten',
  'voucherList.openInBank': 'In Bank öffnen',
  'voucherList.editPosting': 'Buchung bearbeiten',
  'voucherList.correctPosting': 'Beleg korrigieren',
  'voucherList.editMileage': 'Fahrtenbuch bearbeiten',
  'voucherList.openInVat': 'In MwSt. öffnen',
  'voucherList.edit': 'Bearbeiten',
  'voucherList.purchaseNotFound': 'Der zu bearbeitende Kauf wurde nicht gefunden. Aktualisiere die Seite und öffne den Beleg erneut.',
  'voucherList.saleNotFound': 'Der zu bearbeitende Verkauf wurde nicht gefunden. Aktualisiere die Seite und öffne den Beleg erneut.',
  'inboxStatus.alreadyBooked': 'Bereits gebucht?',
  'inboxStatus.booked': 'Gebucht',
  'inboxStatus.inTrash': 'Im Papierkorb',
  'inboxStatus.readyToBook': 'Bereit zum Buchen',
  'inboxStatus.needsReview': 'Prüfung erforderlich',
  'inboxStatus.analysisFailed': 'Analyse fehlgeschlagen',
  'inboxStatus.analyzing': 'Wird analysiert',
  'inboxStatus.awaitingAnalysis': 'Wartet auf Analyse',
  'inboxStatus.show': 'Anzeigen',
  'inboxStatus.hide': 'Ausblenden',
  'inboxStatus.dropReceipts': 'Belege hier ablegen',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma liest aus, was möglich ist',
  'inboxStatus.dropDocuments': 'Dokumente hier ablegen',
  'inboxStatus.dropDocumentsHint': 'Wird unter Dokumentation abgelegt',
  'inboxStatus.bookWithSuperPlumma': 'Mit SuperPlumma buchen',
  'inboxStatus.saving': 'Wird gespeichert...',
  'purchaseFlow.stepReceipt': 'Beleg',
  'purchaseFlow.stepDetails': 'Details',
  'purchaseFlow.stepLines': 'Zeilen',
  'purchaseFlow.stepPreview': 'Vorschau',
  'purchaseFlow.typeRegular': 'Bezahlter Einkauf',
  'purchaseFlow.typeInvoice': 'Lieferantenrechnung',
  'purchaseFlow.typeDrafts': 'Entwürfe',
  'purchaseFlow.receivedReading': 'Beleg erhalten - SuperPlumma liest ihn gerade',
  'purchaseFlow.receivedReadingMany': '{count} Belege erhalten - SuperPlumma liest sie gerade',
  'purchaseFlow.prefilled': 'SuperPlumma hat ausgefüllt, was sich aus dem Beleg lesen ließ. Prüfe alles, bevor du buchst.',
  'purchaseFlow.amountReview': 'Beträge und MwSt. konnten nicht sicher ausgefüllt werden. Prüfe den Beleg und gib pro Zeile den Nettobetrag und die richtige MwSt.-Behandlung ein, bevor du buchst.',
  'purchaseFlow.analysisFailed': 'Der Beleg wurde hochgeladen, aber die Analyse ist fehlgeschlagen.',
  'purchaseFlow.inboxResolveFailed': 'Die Buchung ist gespeichert, aber der Beleg wurde nicht aus dem Posteingang entfernt. Markiere ihn dort als gebucht.',
  'purchaseFlow.receiptFallbackName': 'Beleg',
});
